import * as React from "react";
import type { RouterContext } from "../router-context";

// The boot-time services (config, auth, API) for components; routes read the same object as router context.
const Ctx = React.createContext<RouterContext | null>(null);

export function RuntimeProvider({ value, children }: { value: RouterContext; children: React.ReactNode }) {
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useRuntime(): RouterContext {
  const v = React.useContext(Ctx);
  if (!v) throw new Error("useRuntime needs a RuntimeProvider");
  return v;
}
